<div class="dialog">
  <header mat-dialog-title class="header">
    <h2 class="header__title">{{ 'KNOWLEDGE_SHARING.CREATE.TITLE' | translate }}</h2>
  </header>

  <mat-dialog-content class="content">
    <p class="lede">{{ 'KNOWLEDGE_SHARING.CREATE.LEDE' | translate }}</p>

    <glxy-form-field class="field">
      <glxy-label>{{ 'KNOWLEDGE_SHARING.CREATE.NAME' | translate }}</glxy-label>
      <input
        matInput
        [ngModel]="name()"
        (ngModelChange)="name.set($event)"
        [placeholder]="'KNOWLEDGE_SHARING.CREATE.NAME_PLACEHOLDER' | translate"
        maxlength="80"
      />
    </glxy-form-field>

    <glxy-form-field class="field">
      <glxy-label>{{ 'KNOWLEDGE_SHARING.CREATE.DESCRIPTION' | translate }}</glxy-label>
      <textarea
        matInput
        rows="2"
        [ngModel]="description()"
        (ngModelChange)="description.set($event)"
        [placeholder]="'KNOWLEDGE_SHARING.CREATE.DESCRIPTION_PLACEHOLDER' | translate"
        maxlength="200"
      ></textarea>
    </glxy-form-field>

    <section class="sources">
      <header class="sources__head">
        <h3 class="sources__title">{{ 'KNOWLEDGE_SHARING.CREATE.SOURCES_TITLE' | translate }}</h3>
        <span class="sources__hint">{{ 'KNOWLEDGE_SHARING.CREATE.SOURCES_HINT' | translate }}</span>
      </header>

      @if (data.availableSources.length > 4) {
        <glxy-form-field class="sources__search" suffixIcon="search" bottomSpacing="none" [showLabel]="false">
          <glxy-label>{{ 'COMMON.SEARCH' | translate }}</glxy-label>
          <input
            matInput
            [ngModel]="search()"
            (ngModelChange)="search.set($event)"
            [placeholder]="'KNOWLEDGE_SHARING.CREATE.SEARCH_PLACEHOLDER' | translate"
          />
        </glxy-form-field>
      }

      <ul class="sources__list">
        @for (ks of filteredSources(); track ks.id) {
          <li class="sources__row">
            <mat-checkbox
              color="primary"
              [checked]="isSelected(ks)"
              (change)="toggle(ks, $event.checked)"
            >
              <div class="sources__label">
                <mat-icon class="sources__icon">{{ iconFor(ks.kind) }}</mat-icon>
                <div class="sources__text">
                  <div class="sources__name">{{ ks.name }}</div>
                  @if (ks.subtitle) {
                    <div class="sources__sub">{{ ks.subtitle }}</div>
                  }
                </div>
              </div>
            </mat-checkbox>
          </li>
        } @empty {
          <li class="sources__empty">{{ 'KNOWLEDGE_SHARING.CREATE.NO_MATCHING_SOURCES' | translate }}</li>
        }
      </ul>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="actions">
    <span class="actions__count">
      {{
        (selectedCount() === 0
          ? 'KNOWLEDGE_SHARING.CREATE.NO_SOURCES_SELECTED'
          : 'KNOWLEDGE_SHARING.CREATE.SOURCES_SELECTED'
        ) | translate: { count: selectedCount() }
      }}
    </span>
    <button mat-button [disabled]="submitting()" (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="name().trim().length === 0 || submitting()"
      (click)="create()"
    >
      {{ 'KNOWLEDGE_SHARING.CREATE.CREATE' | translate }}
    </button>
  </mat-dialog-actions>
</div>
